export default {
    // Common
    cardDeck: {
        noPostsText: 'Currently there are no posts available.',
        loadMore: 'Read more stories',
    },
};
